<template>
  <layout-default-filters @open="$_OnOpen" @apply="$_applyQueryString"
  :hideButton="filtroInicial">
    <template #superior>
    <div class='div-geral'>
      
      <div class='primeiro-filtro'>
        <v-form ref="form" >
          <core-text-field
            clearable
            v-model="filters.cidade"
            label='Cidade'
            min="0"
            @keydown="bloquearCaracteresInvalidos"
            @input="garantirPositivo('cliente')"
            placeholder="Filtrar por cidade"
          />
          <!-- <core-text-field
            clearable
            v-model="filters.semVendas"
            label='Sem vendas (dias)'
            type="number"
            min="0"
            @keydown="bloquearCaracteresInvalidos"
            @input="garantirPositivo('cliente')"
            placeholder="Ex: 30"
          /> -->
        </v-form >
      </div>

      <div class='segundo-filtro'>
<!-- 
        <div v-if="filtroAtivo === null">
          <core-text-field
            clearable class='txt-filter'
            @focus="ativarFiltro('pessoa')"
            v-model="nomePessoa"
            label='Cliente'
            min="0"
            @keydown="bloquearCaracteresInvalidos"
            @input="garantirPositivo('cliente')"
            :type='inputType'
          />
        </div> -->

        <div v-if="filtroAtivo === 'pessoa'">
          <div class='radios' :class="{ 'visible': filtroAtivo === 'pessoa' }">
            <v-radio-group v-model="radioPessoa" hide-details class="mt-0">
              <v-row dense>
                <v-col cols="6" class="py-0">
                  <v-radio :label="radioLabelPessoa" :value="1"></v-radio>
                  <v-radio :label="radioLabelPessoa" :value="2"></v-radio>
                </v-col>
                <v-col cols="6" class="py-0 pb-3">
                  <v-radio :label="radioLabelPessoa" :value="3"></v-radio>
                  <v-radio :label="radioLabelPessoa" :value="4"></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </div>
          <core-text-field
            clearable class='txt-filter'
            @focus="ativarFiltro('pessoa')"
            @keyup.enter="$_load(1)" 
            v-model="nomePessoa"
            min="0"
            @keydown="bloquearCaracteresInvalidos"
            @input="garantirPositivo('cliente')"
            label='Pesquisar Cliente...'
            :type='inputType'
          />
          <div class='btns-wrap' :class="{ 'visible': filtroAtivo === 'pessoa' }">
            <v-btn rounded color='primary' class='btns' @click='$_load(0)'>
              <v-icon>mdi-arrow-left-thick</v-icon>
            </v-btn>
            <v-btn rounded color='primary' class='btns reducesize' @click='$_load(1)'>
              <v-icon>mdi-arrow-left-thick</v-icon><v-icon>mdi-arrow-right-thick</v-icon> </v-btn>
            <v-btn rounded color='primary' class='btns-mini' @click='$_load(2)'>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <template v-if="filtroAtivo === 'pessoa'">
            <v-divider></v-divider>
            <div class="mx-auto cardlist" max-width="500">
               <div v-if="loading" class="text-center pa-4">
                 <v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
                 <div class="text-caption mt-2">Buscando...</div>
              </div>

              <v-list two-line class='scroll' v-else>
                <v-list-item-group active-class="green--text" multiple>
                  <template v-for="(item, index) in itemsPessoa">
                    <v-list-item :key="item.id + '-' + index">
                      <v-card class='cardpessoa' @click="$_onClickCard(item.clinome, item.cliidcliente)">
                        {{ item.cliidcliente }} - {{ item.clinome }} - {{ item.clicpf }}
                      </v-card>
                    </v-list-item>
                    <v-divider v-if="index < itemsPessoa.length - 1" :key="index"></v-divider>
                  </template>
                  <v-list-item v-if="itemsPessoa.length === 0 && nomePessoa">
                    <v-list-item-content>
                      <v-list-item-title class="text-center grey--text">Nenhum cliente encontrado.</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </div>
            <v-divider></v-divider>
          </template>
        </div>
        
        </div>
    </div>
    </template>
  </layout-default-filters>
</template>

<script>
import { mapMutations } from 'vuex';
import db from '@/plugins/dexie';
import { PESQUISA_CADASTRO_CLIENTE_STORAGE } from '@/constants/STORAGE';
import { getQueryValue, setQueryValue } from '@/services/query-string';
import LayoutDefaultFilters from '@/layouts/default/NewFilters.vue';
import CoreTextField from '@/components/core/text-field/Index.vue';
import errorHandler from '@/utils/error-handler';
import storage from '@/services/storage';

export default {
  name: 'ViewPesquisaClienteFilters',

  components: {
    LayoutDefaultFilters,
    CoreTextField,
  },

  data() {
    return {
      filtroAtivo: null,
      filtroInicial: false,
      inputType: 'text',
      loading: false,

      itemsPessoa: [],
      radioPessoa: 2,
      radioLabelPessoa: ['Código', 'Razão', 'CNPJ', 'Fantasia'],
      nomePessoa: null,

      filters: {
        codigopessoa: null,
        cidade: null,
        semVendas: null,
      },
    };
  },

  methods: {
    ...mapMutations({
      $_setRefresh: 'filter/refresh',
    }),

    garantirPositivo() {
      if (this.termoBusca && this.termoBusca < 0) {
        this.termoBusca = Math.abs(this.termoBusca).toString();
      }
    },

    bloquearCaracteresInvalidos(e) {
      if (['-', '+'].includes(e.key)) {
        e.preventDefault();
      }
    },

    ativarFiltro(nomeFiltro) {
      this.filtroAtivo = nomeFiltro;
      this.filters.codigopessoa = null;
      if (!this.filtroInicial) {
        this.subirForm(true);
      }
      
      if (this.radioPessoa === 1 || this.radioPessoa === 3) {
         this.inputType = 'number';
      } else {
         this.inputType = 'text';
      }

      if (this.nomePessoa) {
        this.$_load(1);
      }
    },

    async $_load(parametroLoad) {
      if (parametroLoad === 2) {
        this.nomePessoa = null;
        this.filters.codigopessoa = null;
        storage.setItem(PESQUISA_CADASTRO_CLIENTE_STORAGE.textofiltro, '');
        this.itemsPessoa = [];
        this.subirForm(0);
        this.loading = false;
        return;
      }

      this.loading = true;
      try {
        if (this.filtroAtivo === 'pessoa') {
          const resultadosLocais = await this.buscarNoDexie(parametroLoad);
          
          if (resultadosLocais.length > 0) {
            this.itemsPessoa = this.removerDuplicados(resultadosLocais);
          } else {
            if (this.nomePessoa && this.nomePessoa.length > 0) {
                await this.buscarNaApiESalvar();
                
                const novosLocais = await this.buscarNoDexie(parametroLoad);
                this.itemsPessoa = this.removerDuplicados(novosLocais);
            } else {
              this.itemsPessoa = [];
            }
          }
        } else {
          this.itemsPessoa = []; 
        }
      } catch (err) {
        errorHandler.call(this, err);
      } finally {
        this.loading = false;
      }
    },

    removerDuplicados(lista) {
      const unicos = [];
      const idsVistos = new Set();

      lista.forEach(item => {
        if (!idsVistos.has(item.cliidcliente)) {
          idsVistos.add(item.cliidcliente);
          unicos.push(item);
        }
      });
      return unicos;
    },

    parseDataParaTimestamp(dataStr) {
      if (!dataStr) return null;

      try {
        let dateObj = null;

        if (typeof dataStr === 'string' && dataStr.includes('/')) {
          const parts = dataStr.split('/');
          if (parts.length === 3) {
            const dia = parseInt(parts, 10);
            const mes = parseInt(parts, 10) - 1;
            const ano = parseInt(parts, 10);
            dateObj = new Date(ano, mes, dia);
          }
        } 
        else {
          dateObj = new Date(dataStr);
        }

        if (dateObj && !isNaN(dateObj.getTime())) {
          dateObj.setHours(0, 0, 0, 0);
          return dateObj.getTime();
        }
      } catch (e) {
        console.error("Erro ao converter data:", dataStr, e);
      }
      
      return null;
    },

  async buscarNoDexie(tipoBusca) {
    const texto = this.nomePessoa ? this.nomePessoa.trim() : '';
    const textoLower = texto.toLowerCase();
    const textoLimpo = texto.replace(/\D/g, '');
    const cidadeFiltro = this.filters.cidade ? this.filters.cidade.trim().toLowerCase() : null;

    let dataLimiteMs = null;
    const diasInput = this.filters.semVendas ? parseInt(this.filters.semVendas) : null;

    if (diasInput !== null && !isNaN(diasInput) && diasInput >= 0) {
        const dataCorte = new Date();
        dataCorte.setHours(0, 0, 0, 0); 
        dataCorte.setDate(dataCorte.getDate() - diasInput);
        dataLimiteMs = dataCorte.getTime();
    }

    try {
      let collection = db.cliente.toCollection();

      return await collection.filter(cliente => {
        
        if (dataLimiteMs !== null) {
            const ultimaVendaMs = this.parseDataParaTimestamp(cliente.cliultvda);

            if (ultimaVendaMs !== null) {
                if (ultimaVendaMs > dataLimiteMs) {
                    return false; 
                }
            } 
        }

        if (cidadeFiltro) {
            if (!cliente.clicidade || !cliente.clicidade.toLowerCase().includes(cidadeFiltro)) {
                return false;
            }
        }

        if (texto === '') return true;

        if (this.radioPessoa === 1) {
            const idStr = cliente.cliidcliente.toString();
            return (tipoBusca === 0) ? idStr.startsWith(textoLimpo) : idStr.includes(textoLimpo);
        }
        
        if (this.radioPessoa === 2) {
            if (!cliente.clinome) return false;
            const nome = cliente.clinome.toLowerCase();
            return (tipoBusca === 0) ? nome.startsWith(textoLower) : nome.includes(textoLower);
        }
        
        if (this.radioPessoa === 3) {
            if (!cliente.clicpf) return false;
            const dbCnpj = cliente.clicpf.replace(/\D/g, '');
            return (tipoBusca === 0) ? dbCnpj.startsWith(textoLimpo) : dbCnpj.includes(textoLimpo);
        }
        
        if (this.radioPessoa === 4) {
            if (!cliente.clinomefantasia) return false;
            const fantasia = cliente.clinomefantasia.toLowerCase();
            return (tipoBusca === 0) ? fantasia.startsWith(textoLower) : fantasia.includes(textoLower);
        }

        return false;
      })
      .limit(50) 
      .toArray();

    } catch (e) {
      console.warn("Erro na query do Dexie:", e);
      return [];
    }
  },

    async buscarNaApiESalvar() {
      try {
        const paramsApi = {
            page: 1,
            limit: 50,
            idcliente: 0,
            Nome: null,
            Fantasia: null,
            Cnpj_cpf: null,
            IdVendedor: 0
        };

        const texto = this.nomePessoa.trim();

        if (this.radioPessoa === 1) paramsApi.idcliente = texto;
        if (this.radioPessoa === 2) paramsApi.Nome = texto;
        if (this.radioPessoa === 3) paramsApi.Cnpj_cpf = texto;
        if (this.radioPessoa === 4) paramsApi.Fantasia = texto;

        const respostaApi = await this.getListaClientes(paramsApi);
        const listaDaApi = Array.isArray(respostaApi) ? respostaApi : (respostaApi.data || []);

        if (listaDaApi.length > 0) {
            const dadosParaDexie = listaDaApi.map(c => ({
              cliidnuvem: c.IdCliente,
              clidataalteracao: c.DataAlteracao,
              cliidcliente: c.IdCliente,
              clinome: c.Nome,
              clicpf: c.CNPJ_CPF,
              clinomefantasia: c.Fantasia,
              cliendereco: c.Endereco,
              clicidade: c.Cidade,
              clibairro: c.Bairro,
              cliuf: c.UF,
              clicep: c.Cep,
              cliinscricaoestadual: c.InscricaoEstadual,
              clifone: c.Fone,
              cliemail: c.Email,
              clibloqueado: c.Bloqueado,
              clirestricao: c.Restricao,
              clilimitecredito: c.LimiteCredito,
              cliprivda: c.PriVDA,
              cliqtdevda: c.qtdeVDA,
              cliultvda: c.UltVDA,
              cliidforma: c.Idforma,
              cliidplanopagto: c.IdPlanoPagto,
              cliidvendedor: c.IdVendedor
            }));

            await db.cliente.bulkPut(dadosParaDexie);
        }
      } catch (error) {
        console.warn("API offline ou vazia.", error);
      }
    },

    $_applyQueryString() {
      setQueryValue('codigopessoa', null);
      setQueryValue('nome', null);
      setQueryValue('cnpj', null);
      setQueryValue('fantasia', null);
      if (this.filters.codigopessoa) {
        setQueryValue('codigopessoa', this.filters.codigopessoa);
      } 
      else if (this.nomePessoa) {
        const texto = this.nomePessoa.trim();
        let valorFinal = texto;
        
        if (this.radioPessoa === 1) {
            const match = texto.match(/^(\d+)\s-\s/);
            if (match) {
              valorFinal = match; 
            }
            setQueryValue('codigopessoa', valorFinal);
        } 
        else {
            if (this.radioPessoa === 2) setQueryValue('nome', valorFinal);
            if (this.radioPessoa === 3) setQueryValue('cnpj', valorFinal);
            if (this.radioPessoa === 4) setQueryValue('fantasia', valorFinal);
        }
      }
      setQueryValue('cidade', this.filters.cidade || null);
      setQueryValue('semVendas', this.filters.semVendas || null);

    },

    $_OnOpen() {
      this.subirForm(false);
    },

    subirForm(bool) {
      if (bool) {
        if (this.filtroInicial) { return; }
        document.querySelector('.primeiro-filtro').style.opacity = '0';
        document.querySelector('.primeiro-filtro').style.zIndex = '-1';
        if (this.$_isMobile) document.querySelector('.segundo-filtro').style.top = '-210px';
        else document.querySelector('.segundo-filtro').style.top = '-180px';
        
        this.filtroInicial = true;
      } else {
        if (!this.filtroInicial) { return; }
        document.querySelector('.primeiro-filtro').style.opacity = '1';
        document.querySelector('.primeiro-filtro').style.zIndex = '2';
        if (this.$_isMobile) document.querySelector('.segundo-filtro').style.top = '0';
        else document.querySelector('.segundo-filtro').style.top = '0';
        
        this.filtroInicial = false;
        this.filtroAtivo = null;
      }
    },

    $_onClickCard(nome, codigo) {
      if (this.filtroInicial) {
        if (this.filtroAtivo === 'pessoa') {
          this.nomePessoa = `${codigo} - ${nome}`;
          storage.setItem(PESQUISA_CADASTRO_CLIENTE_STORAGE.textofiltro, this.nomePessoa);
          
          this.filters.codigopessoa = codigo;
        }
        this.$_applyQueryString();
        this.subirForm(0);
      }
    },
  },

  watch: {
    radioPessoa() {
      this.itemsPessoa = [];
      if (this.radioPessoa === 1 || this.radioPessoa === 3) {
        this.inputType = 'number';
      } else {
        this.inputType = 'text';
      }
      if (this.nomePessoa) this.$_load(1);
    },

    $route: {
      deep: true,
      immediate: true,
      async handler() {
        this.filters.cidade = getQueryValue('cidade', null);
        this.filters.semVendas = getQueryValue('semVendas', null);
        
        const cod = getQueryValue('codigopessoa', null);
        const nome = getQueryValue('nome', null);
        const cnpj = getQueryValue('cnpj', null);
        const fantasia = getQueryValue('fantasia', null);

        if (cod) { 
          if (!this.nomePessoa) {
              this.nomePessoa = cod; 
          }
        }
        else if (nome) { this.nomePessoa = nome; this.radioPessoa = 2; }
        else if (cnpj) { this.nomePessoa = cnpj; this.radioPessoa = 3; }
        else if (fantasia) { this.nomePessoa = fantasia; this.radioPessoa = 4; }
        else { 
            const valorSalvo = await storage.getItem(PESQUISA_CADASTRO_CLIENTE_STORAGE.textofiltro);
            if (typeof valorSalvo === 'object' && valorSalvo !== null) {
                this.nomePessoa = null;
            } else {
                this.nomePessoa = valorSalvo || null;
            }
        }
      },
    },

    'filters.semVendas': function() {
        if (this.timerSemVendas) clearTimeout(this.timerSemVendas);
        
        this.timerSemVendas = setTimeout(() => {
            this.$_load(1);
        }, 500);
    },

    'filters.cidade': function() {
        if (this.timerCidade) clearTimeout(this.timerCidade);
        
        this.timerCidade = setTimeout(() => {
            this.$_load(1);
        }, 500);
    },
},
};
</script>

<style scoped>
  .div-geral {
    height: 0%;
  }

  .btns-wrap {
    display: flex;
    justify-content: space-around;
    height: 50px;
    transition: opacity 0.3s;
    opacity: 0;
  }

  .btns {
    width: 33%;
    transition: opacity 0.3s;
  }

  .btns-mini {
    width: 10%;
    transition: opacity 0.3s;
  }

  .primeiro-filtro {
    transition: opacity 0.3s;
    position: relative;
    opacity: 1;
    z-index: 1;
  }

  .segundo-filtro {
    transition: top 0.4s;
    position: relative;
    z-index: 1;
    height: 0px;
  }

  .radios {
    transition: opacity 0.3s;
    opacity: 0;
    height: auto; 
  }

  .radios.visible,
  .btns-wrap.visible {
    opacity: 1;
  }


  .mx-auto.cardlist {
    transition: opacity 0.3s;
    transition: top 0.4s; 
    height: 50vh;
    overflow-y: scroll;
    background-color: rgb(245, 245, 245);
  }

  .cardpessoa {
    height: 80px;
    width: 100%;
    margin-top: 5px;
  }

  .txt-filter {
    height: 50px;
  }
</style>